import React, { Component } from 'react';
import somethingWentWrong from "./views/assets/lottie/some-went-wrong.json";
import Lottie from 'lottie-react';
import DefaultButton from './views/components/buttons/defaultButton';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        // console.error('ERROR BOUNDARIES TRIGGER :', error, errorInfo);
        this.setState({ error: error, errorInfo: errorInfo });
    }

    render() {
        if (this.state.hasError || this.state.error) {
            // You can render any custom fallback UI
            return (
                <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
                    <div className="w-full min-h-screen flex flex-col justify-center items-center gap-4 max-w-3xl mx-auto">
                        <Lottie
                            animationData={somethingWentWrong}
                            loop={true}
                            className="h-[200px]"
                        />
                        <div className="flex flex-col gap-2 items-center justify-center text-center">
                            <h1 className="text-4xl font-bold">Something Went Wrong</h1>
                            <p>
                                We’re sorry, but something didn’t go as expected. This might be due to
                                a temporary server issue, a problem with your internet connection, or
                                an unexpected error in the system.
                            </p>
                        </div>
                        <div className="flex flex-row gap-2 items-center justify-center">
                            <DefaultButton
                                variant="outline"
                                name={"Go Home"}
                                onClick={() => window.location.assign('/')}
                            />
                            <DefaultButton name={"Reload"}
                                onClick={() => window.location.reload()}
                            />
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;